import { getTemplate as getCommonColumnTemplate } from './commonColumns';
import { getTemplate as getActionColumnTemplate } from './actionColumns';
import { getTemplate as getCustomColumnTemplate } from './customColumns';

const templates = {
  getCommonColumnTemplate,
  getActionColumnTemplate,
  getCustomColumnTemplate,
};

export default templates;
